import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'

const commonStyles = css`
  ${({ theme }) => css`
    position: relative;
    padding: ${theme.spacing(2.5)} ${theme.spacing(4)};
    font-size: 2rem;
    text-align: center;
    background-color: ${theme.secondary_color};
    color: black;
    border: none;
    background-clip: padding-box;
    transform: translateZ(0);
    overflow: hidden;

    &::after,
    &::before {
      content: '';
      position: absolute;
      z-index: -1;
    }

    &::before {
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }

    &::after {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      height: 0;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }

    &:hover:not(:disabled)::after {
      animation: hover-in-transactional 0.6s cubic-bezier(0.6, 0.1, 0.9, 0.6) forwards;
    }

    &:active:not(:disabled) {
      animation: clicked-on-transactional 0.3s ease-in;
    }

    &.white {
      background-color: ${theme.palette.white};

      &:hover:not(:disabled)::after {
        animation: hover-in 0.6s cubic-bezier(0.6, 0.1, 0.9, 0.6) forwards;
      }

      &:active:not(:disabled) {
        animation: clicked-on 0.3s ease-in;
      }
    }

    &.secondary {
      background-color: ${theme.palette.grey[300]};
      color: ${theme.palette.black};

      &:hover:not(:disabled)::after {
        animation: hover-in 0.6s cubic-bezier(0.6, 0.1, 0.9, 0.6) forwards;
      }

      &:active:not(:disabled) {
        animation: clicked-on 0.3s ease-in;
      }
    }
  `}
`

const Button = styled.button`
  ${commonStyles}
`

const ButtonLink = styled(Link)`
  ${commonStyles}
  display: inline-block;
  text-decoration: none;
`

export default {
  Button,
  ButtonLink,
}
